import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ApiService } from './api.service';
import { OutboundFaxImport } from 'app/core/models/outbound-fax-import.model';
import { LimitOffsetPagingMeta } from '../models/paged-results/limit-offset-paging.model';
import { PagedResults } from '../models/paged-results/paged-results.model';

export class AttachedFile {
  url: string;
}

export class PagedCuratedSpecialtiesImports implements PagedResults {
  outboundFaxImports: OutboundFaxImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.outboundFaxImports;
  }
}

@Injectable()
export class OutboundFaxImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id: number): Observable<OutboundFaxImport> {
    return this.http.get<OutboundFaxImport>(`${environment.captureApi.url}/outbound_fax_imports/${id}`);
  }

  getList(
    paging: { page: number; pageSize: number } = null,
  ): Observable<PagedCuratedSpecialtiesImports> {
    const params = new URLSearchParams();

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedCuratedSpecialtiesImports>(
      `${environment.captureApi.url}/outbound_fax_imports?${params.toString()}`
    );
  }

  create(signedId: string): Observable<OutboundFaxImport> {
    return this.http.post<OutboundFaxImport>(`${environment.captureApi.url}/outbound_fax_imports`, {
      outboundFaxImport: { signedId },
    });
  }

  cancel(id: number): Observable<OutboundFaxImport> {
    return this.http.patch<OutboundFaxImport>(`${environment.captureApi.url}/outbound_fax_imports/${id}/cancel`, {});
  }

  generateSkippedFile(id: number): Observable<{ skippedFile: AttachedFile }> {
    return this.http.put<{ skippedFile: AttachedFile }>(`${environment.captureApi.url}/outbound_fax_imports/${id}/generate_skipped_file`, {});
  }

  generateOutcomeFile(id: number): Observable<{ outcomeFile: AttachedFile }> {
    return this.http.put<{ outcomeFile: AttachedFile }>(`${environment.captureApi.url}/outbound_fax_imports/${id}/generate_outcome_file`, {});
  }
}
